import { NfzContractingPartyType } from '@dreryk/egabinet-nfz-configuration-frontend-api';

import { FieldControllerProps } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../translations';

export const CONTRACTING_PARTY_TYPE_RADIO_ITEMS: RadioGroupItem<NfzContractingPartyType>[] = [
   {
      id: 'PERSON',
      label: nfzSettingsTranslationKeys.contractingPartyTypeOptions.person,
   },
   {
      id: 'PROVIDER',
      label: nfzSettingsTranslationKeys.contractingPartyTypeOptions.provider,
   },
];

type ContractingPartyTypeRadioGroupProps = FieldControllerProps<'contractingPartyType', NfzContractingPartyType>;

export const ContractingPartyTypeRadioGroup = (props: ContractingPartyTypeRadioGroupProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: {
         message: nfzSettingsTranslationKeys.chooseContractingPartyType,
         value: Boolean(props.required),
      },
   });

   return (
      <RadioGroup<NfzContractingPartyType>
         testId={props.name}
         items={CONTRACTING_PARTY_TYPE_RADIO_ITEMS}
         controller={controller}
         label={nfzSettingsTranslationKeys.contractingPartyType}
         defaultValue={props.defaultValue}
      />
   );
};
